import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button,
} from "@mui/material";
import default_theme from "assets/themes/themes";
import styles from "../../../pages/main/WorkspacesPage/WorkspacesPage.module.css";

const DeleteProjectDialog = ({ open, onClose, onConfirm, projectName }) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle
                variant="h5"
                className={styles.dialogTitle}
            >
                Delete Project
            </DialogTitle>

            <DialogContent sx={{ pt: 2 }}>
                <Typography
                    variant="h6"
                    sx={{ fontWeight: 600, mb: 1, color: "#23576B" }}

                >
                    Are you sure you want to delete the project{" "}
                    <strong>"{projectName}"</strong>?
                </Typography>

                <Typography
                    variant="body1"
                    sx={{ color: "#7898A4", mb: 4 }}
                >
                    This action is permanent and cannot be undone. Deleting this project will
                    remove all associated data, including your progress, configurations, and
                    any content linked to it.
                </Typography>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}
                    variant="contained"
                    className={styles.projectButton}
                >
                    Cancel
                </Button>

                <Button
                    onClick={onConfirm}
                    variant="contained"
                    className={styles.projectDeleteButton}
                >
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteProjectDialog;